import React, { ReactNode } from 'react';
import classNames from 'classnames';

type Props = {
  tabId: string;
  onClick: (id: string) => void;
  selectedTab: string;
  children: ReactNode;
};

const MemberOnlyTabButton = ({
  tabId,
  onClick,
  selectedTab,
  children
}: Props) => (
    <button
      type="button"
      className={classNames(
        'px-3 pt-3 font-bold text-base cursor-pointer',
        selectedTab !== tabId && 'text-neutral-400'
      )}
      onClick={() => onClick(tabId)}
    >
      {children}
      <div
        className={classNames(
          'border-b-4 mt-2.5 rounded-lg',
          selectedTab === tabId ? 'border-primary-500' : 'border-transparent'
        )}
      />
    </button>
  );

export default MemberOnlyTabButton;
